import { render } from "./PriorityTag.vue?vue&type=template&id=7848aacb"
import script from "./PriorityTag.vue?vue&type=script&lang=js"
export * from "./PriorityTag.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__